import { render } from "./Index.vue?vue&type=template&id=c7faa994&scoped=true"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import "./Index.vue?vue&type=style&index=0&id=c7faa994&scoped=true&lang=scss"
import "./Index.vue?vue&type=style&index=1&id=c7faa994&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c7faa994"]])

export default __exports__